import { render, staticRenderFns } from "./NuevoEvento.vue?vue&type=template&id=7d8d7c34&"
import script from "./NuevoEvento.vue?vue&type=script&lang=js&"
export * from "./NuevoEvento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports